import { Validators } from "@angular/forms";
import { DataTypes } from "../shared/Enums/DataTypesEnum";
import { noWhiteSpaceValidator } from "src/validators/noWhiteSpace.validator";
import { BIEntity, BIEntity_Controls, IControls } from "BI-Libraries/BI-Interfaces/dist/bi-interfaces";

export class ChangePassword_Entity extends BIEntity
{
    EntityName= 'ChangePassword';
    ODATAAPIURL= 'ChangePassword';
    POSTAPIURL = 'ChangePassword';
    PUTAPIURL = 'ChangePassword';
    DELETEAPIURL = 'ChangePassword';
    Fields = [
    {
        FieldName:'CurrentPassword', 
        DataType: DataTypes.Text,
        IsPrimaryKey: true,     
        IsEditable: false,
        IsSubmitExcluded: false,
        IsFilterable: true,
        DefaultValue: null,
        Width: 40,
        Validators: Validators.compose([Validators.required,noWhiteSpaceValidator(""),Validators.maxLength(15)])
    },
    {
        FieldName:'NewPassword', 
        DataType: DataTypes.Text,
        IsPrimaryKey: false,     
        IsEditable: true,
        IsSubmitExcluded: false,
        IsFilterable: true,
        DefaultValue: null,
        Width: 200,
        Validators: Validators.compose([Validators.maxLength(200)])
    },
    {
        FieldName:'NewPasswordConfirm', 
        DataType: DataTypes.Text,
        IsPrimaryKey: false,     
        IsEditable: true,
        IsSubmitExcluded: false,
        IsFilterable: true,
        DefaultValue: null,
        Width: 200,
        Validators: Validators.compose([Validators.maxLength(200)])
    }
    ]
}

    export class ChangePassword_Controls extends BIEntity_Controls
    {
        readonly DBTable:ChangePassword_Entity;
        protected ControlList:IControls[]=[]
        constructor()
        {
            super();
            this.DBTable = new ChangePassword_Entity();
        }
    }